"use client";
import {
  PopoverContextProvider
} from "../__chunks/TE637IA7.js";
import "../__chunks/XXVAHUAO.js";
import "../__chunks/J55AVALY.js";
import "../__chunks/5M6RSQEC.js";
import {
  usePopoverStore
} from "../__chunks/XWCFCD3Q.js";
import "../__chunks/I62TROYO.js";
import "../__chunks/HZJ2XALY.js";
import "../__chunks/EKQEJRUF.js";
import "../__chunks/6O5OEQGF.js";
import "../__chunks/XM66DUTO.js";
import "../__chunks/4R3V3JGP.js";

// src/popover/popover-provider.tsx
import { jsx } from "react/jsx-runtime";
function PopoverProvider(props = {}) {
  const store = usePopoverStore(props);
  return /* @__PURE__ */ jsx(PopoverContextProvider, { value: store, children: props.children });
}
export {
  PopoverProvider
};
